import { apiClient } from '../client';

export interface OrderStatus {
  id: string;
  organization_id: string;
  name: string;
  slug: string;
  color: string;
  is_default: boolean;
  is_system: boolean;
  sort_order: number;
  created_at: string;
  updated_at: string;
}

export const orderStatusesApi = {
  list: async (): Promise<OrderStatus[]> => {
    const res = await apiClient.get('/order-statuses');
    return res.data ?? [];
  },

  create: async (data: { name: string; color?: string; sort_order?: number }): Promise<OrderStatus> => {
    const res = await apiClient.post('/order-statuses', data);
    return res.data;
  },

  update: async (
    statusId: string,
    data: { name?: string; color?: string; sort_order?: number }
  ): Promise<OrderStatus> => {
    const res = await apiClient.put(`/order-statuses/${statusId}`, data);
    return res.data;
  },

  delete: async (statusId: string): Promise<void> => {
    await apiClient.delete(`/order-statuses/${statusId}`);
  },
};
